export default __webpack_public_path__ + "static/media/close-icon-blue.2fcb2061.svg";